import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AdminHeader, Card, Empty } from "@/components/admin/ui";

export default function AdminAuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then(({ data }) => setLogs(data.logs)); }, []);
  return (
    <div>
      <AdminHeader title="Audit Logs" subtitle="Record of administrative actions" />
      <Card className="overflow-hidden">
        <table className="w-full text-sm text-left">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase"><tr><th className="p-3">Time</th><th className="p-3">Actor</th><th className="p-3">Action</th><th className="p-3">Entity</th><th className="p-3">Details</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {logs.map((l) => (
              <tr key={l.id} className="hover:bg-slate-50">
                <td className="p-3 text-xs text-slate-500 whitespace-nowrap">{new Date(l.createdAt).toLocaleString("en-IN")}</td>
                <td className="p-3 text-slate-600">{l.actorEmail}</td>
                <td className="p-3"><span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-slate-100 text-slate-700">{l.action}</span></td>
                <td className="p-3">{l.entity}</td>
                <td className="p-3 text-xs text-slate-500 font-mono">{l.metadata && Object.keys(l.metadata).length ? JSON.stringify(l.metadata) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs.length === 0 && <Empty text="No activity logged yet" />}
      </Card>
    </div>
  );
}
